const code_project = {
  title: 'Academic Code',
  description: 'A collection of code repositories that I\'ve written for computer science courses including robotics, machine learning, and human-computer interaction.',

  sections: [],
  codeLink: [
    {
      title: "Chess-Playing AI",
      course: "COSC 076: Artificial Intelligence",
      language: "Python, PyTorch",
      date: "September 19, 2021",
      target: "https://github.com/benlehrburger/Chess-Playing-AI",
    },
    {
      title: "Classification and Clustering",
      course: "COSC 074: Machine Learning and Statistical Analysis",
      language: "Python, NumPy, Pandas",
      date: "May 21, 2022",
      target: "https://github.com/benlehrburger/Classification-and-Clustering",
    },
    {
      title: "Hidden Markov Models",
      course: "COSC 076: Artificial Intelligence",
      language: "Python, PyTorch",
      date: "October 3, 2021",
      target: "https://github.com/benlehrburger/Hidden-Markov-Models",
    },
    {
      title: "Robotic Operating Systems",
      course: "COSC 081: Robot Design and Programming",
      language: "Python, ROS",
      date: "November 29, 2021",
      target: "https://github.com/benlehrburger/Robotics",
    },
    {
      title: "Object-Oriented Programming",
      course: "COSC 010: Object-Oriented Programming",
      language: "Java",
      date: "December 9, 2020",
      target: "https://github.com/benlehrburger/Object-Oriented-Programming",
    },
    {
      title: "Sudoku Solver",
      course: "COSC 076: Artificial Intelligence",
      language: "Python, TensorFlow",
      date: "October 19, 2021",
      target: "https://github.com/benlehrburger/Sudoku-Solver",
    },
    {
      title: "CalenDart Frontend Design",
      course: "COSC 067: Human-Computer Interaction",
      language: "React, JavaScript",
      date: "May 30, 2023",
      target: "https://github.com/Intro-to-HCI-Spring-2023/p5_v2-group13",
    },
    {
      title: "Autonomous Maze Navigation",
      course: "COSC 076: Artificial Intelligence",
      language: "Python, NumPy",
      date: "December 20, 2021",
      target: "https://github.com/benlehrburger/Maze-World",
    },
    {
      title: "Constraint Satisfaction",
      course: "COSC 076: Artificial Intelligence",
      language: "Python",
      date: "November 2, 2021",
      target: "https://github.com/benlehrburger/Constraint-Satisfaction",
    },
  ],
};

export default code_project;